const ValuePreview = ({label, value}) => {

    return (
        <div className="preview-item mb-3">
            <label className="text-muted">{label}</label>
            <div className="preview-input">
                {value}
            </div>
        </div>
    )
}
export default ValuePreview